import type { ActionReducerMapBuilder, PayloadAction } from '@reduxjs/toolkit';

import { AppServerResponse } from '../../utils/interfaces/generalInterfaces';
import {
  deleteTradeReference,
  getTradeReferences,
  updateTradeReference,
} from '../services/tradeReferenceService';
import { TradeReferenceInitialState } from '../globalSlices/tradeReferenceSlice';
import { TradeReference } from '@dill/dill-shared/dist/src';

export const getTradeReferencesExtraReducer = (
  builder: ActionReducerMapBuilder<TradeReferenceInitialState>
) => {
  const reducerId = 'getTradeReferences';
  builder.addCase(getTradeReferences.pending, (state, action) => {
    state.loadingList = [...new Set([...state.loadingList, reducerId])];
  });
  builder.addCase(
    getTradeReferences.fulfilled,
    (state, action: PayloadAction<AppServerResponse | null>) => {
      state.loadingList = state.loadingList.filter((item) => item !== reducerId);
      state.tradeReferences = action.payload?.data;
    }
  );
  builder.addCase(getTradeReferences.rejected, (state, action: PayloadAction<any>) => {
    state.loadingList = state.loadingList.filter((item) => item !== reducerId);
  });
};

export const updateTradeReferenceExtraReducer = (
  builder: ActionReducerMapBuilder<TradeReferenceInitialState>
) => {
  const reducerId = 'updateTradeReference';
  builder.addCase(updateTradeReference.pending, (state, action) => {
    state.loadingList = [...new Set([...state.loadingList, reducerId])];
  });
  builder.addCase(
    updateTradeReference.fulfilled,
    (state, action: PayloadAction<AppServerResponse | null>) => {
      state.loadingList = state.loadingList.filter((item) => item !== reducerId);
      if (action.payload?.success && action.payload.data) {
        const data = action.payload.data as TradeReference;

        state.tradeReferences = state.tradeReferences.map((item) =>
          item.id === data.id ? data : item
        );
      }
    }
  );
  builder.addCase(updateTradeReference.rejected, (state, action: PayloadAction<any>) => {
    state.loadingList = state.loadingList.filter((item) => item !== reducerId);
  });
};

export const deleteTradeReferenceExtraReducer = (
  builder: ActionReducerMapBuilder<TradeReferenceInitialState>
) => {
  const reducerId = 'deleteTradeReference';
  builder.addCase(deleteTradeReference.pending, (state, action) => {
    state.loadingList = [...new Set([...state.loadingList, reducerId])];
  });
  builder.addCase(
    deleteTradeReference.fulfilled,
    (state, action: PayloadAction<AppServerResponse | null>) => {
      state.loadingList = state.loadingList.filter((item) => item !== reducerId);
    }
  );
  builder.addCase(deleteTradeReference.rejected, (state, action: PayloadAction<any>) => {
    state.loadingList = state.loadingList.filter((item) => item !== reducerId);
  });
};
